import React from "react";
import { Animated } from "react-native";
import { Path } from "react-native-svg";
const AnimatedCustomPath = Animated.createAnimatedComponent(Path);

export const AnimatedPath = ({ configs, toggleBool }) => {
  const ref = React.useRef();
  return <AnimatedCustomPath ref={ref} {...configs} />;
};